import React from 'react'
import { Field, FormikProps } from 'formik'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import RadioInput from '../../../../../../../components/inputs/RadioInput'
import { B1_INITIAL_VALUES } from 'shared'
import { DatePickerInput } from '../../../../../../../components/inputs/DatePickerInput'
import { AccompanyingReportInputsPreview } from '../../../../../../../components/AccompanyingReportInputsPreview'

interface Props {
  formik: FormikProps<any>
}

export const TechnicalFormB1Av2: React.FC<Props> = ({ formik }) => {
  const values = formik.values as typeof B1_INITIAL_VALUES
  return (
    <>
      <FormSectionTwoColumns
        title="a) základní popis stavby"
        subtitle="u změny stavby údaje o jejím současném stavu, závěry stavebně technického, případně stavebně historického průzkumu a výsledky statického posouzení nosných konstrukcí"
        sectionKey="b1a"
      >
        <>
          <div className="sm:col-span-6">
            <AccompanyingReportInputsPreview>
              <div>
                {values.readonly?.a1?.isNewConstruction ? (
                  <>Nová {values.readonly?.a1?.isPersistent ? 'trvalá' : 'dočasná'} stavba</>
                ) : (
                  <>Změna {values.readonly?.a1?.isPersistent ? 'trvalé' : 'dočasné'} stavby</>
                )}
              </div>
            </AccompanyingReportInputsPreview>
            {values.readonly?.a1?.isNewConstruction && (
              <div className=" sm:col-span-6 mt-3">
                <Field
                  name="b1a.buildingDescription"
                  label="Popis stavby"
                  component={RichTextInput}
                  aiHint={`"Popis stavby" u "Nová ${
                    values.readonly?.a1?.isPersistent ? 'trvalá' : 'dočasná'
                  } stavba" v sekci "B1. Celkový popis území a stavby - Základní popis stavby"`}
                  aiShowAccReport={true}
                />
              </div>
            )}
            {!values.readonly?.a1?.isNewConstruction && (
              <div className="">
                <div className="sm:col-span-6 mt-3">
                  <Field
                    name="b1a.currentState"
                    label="Současný stav"
                    component={RichTextInput}
                    aiHint={`"Současný stav" u "Změna ${
                      values.readonly?.a1?.isPersistent ? 'trvalé' : 'dočasné'
                    } stavby" v sekci "B1. Celkový popis území a stavby - Základní popis stavby"`}
                    aiShowAccReport={true}
                  />
                </div>
                <div className="sm:col-span-6 mt-3">
                  <Field
                    name="b1a.technicalState"
                    label="Stavebně technický / stavebně historický průzkum"
                    component={RichTextInput}
                    aiHint={
                      '"Stavebně technický / stavebně historický průzkum" u "Změna trvalé stavby" v sekci "B1. Celkový popis území a stavby - Základní popis stavby"'
                    }
                    aiShowAccReport={true}
                  />
                </div>
                <div className="sm:col-span-6 mt-3">
                  <Field
                    name="b1a.bearingConstructionsCheck"
                    label="Výsledky statické posouzení nosných konstrukcí"
                    component={RichTextInput}
                    aiHint={
                      '"Výsledky statické posouzení nosných konstrukcí" u "Změna trvalé stavby" v sekci "B1. Celkový popis území a stavby - Základní popis stavby"'
                    }
                    aiShowAccReport={true}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="sm:col-span-6">
            {!values.readonly?.a1?.isPersistent && (
              <div className="sm:col-span-6 flex flex-col gap-3 mt-3">
                <Field
                  component={DatePickerInput}
                  name="b1a.temporaryStartDate"
                  selectsStart
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  placeholderText="Od"
                />
                <Field
                  component={DatePickerInput}
                  name="b1a.temporaryEndDate"
                  selectsEnd
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  placeholderText="Do"
                />
              </div>
            )}
          </div>
        </>
      </FormSectionTwoColumns>
    </>
  )
}
